import { FC } from 'react';
import { Block } from './ShowFromLeft.style';

export const ShowFromLeft: FC<{ elementsCount?: number }> = ({ children }) => {
  return <Block>{children}</Block>;
};
